export const toTime = (num) => {
  if (isNaN(num) || num === null || num === 0) {
    return "-";
  }

  num = parseFloat((num + " ").replace(",", ".")) / 1000;

  let m = Math.floor(num / 60);
  let h = Math.floor(m / 60);
  let min = m % 60;

  if (h === 0 && min < 1) {
    return "< 1 min";
  }
  if (h > 0) {
    return `${h} h ${min} min`;
  }

  return `${min} min`;
};

export const changeTimeZone = (date, timeZone) => {
  if (typeof date === "string") {
    return new Date(
      new Date(date).toLocaleString("en-US", {
        timeZone
      })
    );
  }

  return new Date(
    date.toLocaleString("en-US", {
      timeZone
    })
  );
};
